import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';

import { loadableReady } from '@loadable/component';

interface Options {
    id: string;
    ssr: boolean;
    component: React.ReactElement;
}

export function render({ id, ssr, component }: Options) {
    loadableReady(() => {
        const container = document.getElementById(id);
        if (ssr) {
            hydrateRoot(container!, component);
        } else {
            const root = createRoot(container!);
            root.render(component);
        }
    });
}
